import { render, staticRenderFns } from "./vRadioQuestion.vue?vue&type=template&id=34cf5845&scoped=true&"
import script from "./vRadioQuestion.vue?vue&type=script&lang=js&"
export * from "./vRadioQuestion.vue?vue&type=script&lang=js&"
import style0 from "./vRadioQuestion.vue?vue&type=style&index=0&id=34cf5845&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cf5845",
  null
  
)

export default component.exports